import express, { NextFunction, Request, Response } from "express"
import cors from "cors"
import dotenv from "dotenv"

import bodyParser from "body-parser"
import helmet from "helmet"

import { routeGetOnline } from "./routes/online.js"

import tasksRouter from "./routes/tasks.js"
import schedulesRouter from "./routes/schedules.js"
import mealsRouter from "./routes/meals.js"
import recipesRouter from "./routes/recipes.js"

// needed to read the proper .env file, even when index.ts has it
dotenv.config()

console.log("env loaded: ", process.env)

const app = express()
const portnum = process.env.port ?? 2222

// has to come before everything else
if (!process.env.calendar_db_socket_path) {
	console.log(`Using host: localhost with CORS via Express`)
	app.use(cors())
}
app.use(express.json())

// adding Helmet to enhance your API's security
app.use(helmet())

// using bodyParser to parse JSON bodies into JS objects
app.use(bodyParser.json())

app.use((req: Request, res: Response, next: NextFunction): void => {
	// Instantly intercept preflight requests and reply with an explicit 200 OK
	if (req.method === "OPTIONS") {
		// console.log("preflight request, sending 200 OK")
		res.sendStatus(200)
		return
	}

	next()
})

app.get("/", routeGetOnline)

app.use("/tasks", tasksRouter)
app.use("/schedules", schedulesRouter)
app.use("/meals", mealsRouter) // utilizes the RECIPES database
app.use("/recipes", recipesRouter) // utilizes the RECIPES database

// error handling
app.use((error: any, _req: Request, res: Response, _next: () => void) => {
	const statusCode = error.statusCode || 500

	// console.error(err.message, err.stack)

	if (error instanceof AggregateError) {
		console.error("Multiple MySQL errors occurred:")

		// Loop through the individual errors inside the aggregate
		error.errors.forEach((err, index) => {
			console.error(`Error #${index + 1}:`, err.message)
		})
	} else {
		console.error("A single error occurred:", error.message)
	}

	res.status(statusCode).json({ message: error.message })

	return
})

// start the server
app.listen(portnum, (err) => {
	const path = process.env.calendar_db_socket_path ? `https://calendar-api.jba3.com` : `http://localhost`

	console.log(`calendar API is running at: ${path}:${portnum}/`)

	if (err) {
		console.log(`ERROR: ${err}`)
	}
})
